export const adjective = {
	singular: "homeowner",
	plural: "homeowners",
};

export const callToAction = {
	lead: "request a quote",
};
